<template>
  <div class="TwoFactorInstruction">
    <div class="TwoFactorInstruction__title">
      Uruchom zabezpieczenie dwuetapowe (2FA)
    </div>
    <div class="TwoFactorInstruction__point">
      <div class="TwoFactorInstruction__point__number">1</div>
      <div class="TwoFactorInstruction__point__description">
        Pobierz i zainstaluj aplikację Google Authenticator z odpowiedniego
        sklepu na swoim smartphonie
      </div>
    </div>
    <div class="TwoFactorInstruction__point center">
      <div class="TwoFactorInstruction__logos">
        <a
          href="https://apps.apple.com/pl/app/google-authenticator/id388497605?l=pl"
          target="_blank"
        >
          <img src="../../../assets/images/app-store.svg" alt="app store" />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US"
          target="_blank"
        >
          <img src="../../../assets/images/google-play.svg" alt="google play" />
        </a>
      </div>
    </div>
    <div class="TwoFactorInstruction__point">
      <div class="TwoFactorInstruction__point__number">2</div>
      <div class="TwoFactorInstruction__point__description">
        Uruchom aplikację Google Authenticator na swoim smartphonie i wybierz
        opcję “Skanuj kod QR” lub “Wpisz klucz konfiguracyjny”. Następnie
        zeskanuj kod QR wyświetlony na ekranie lub wprowadź ręcznie klucz, który
        wyświetli się po naciśnięciu na kod QR po prawej stronie ekranu.
      </div>
    </div>
    <div class="TwoFactorInstruction__point">
      <div class="TwoFactorInstruction__point__number">3</div>
      <div class="TwoFactorInstruction__point__description">
        Po skonfigurowaniu Google Authenticator, przejdź przez proces
        weryfikacji, który może wymagać podania kodu jednorazowego
        wygenerowanego przez aplikację.
      </div>
    </div>
    <div class="TwoFactorInstruction__point__image">
      <img src="../../../assets/images/2fa-config-instruction.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TwoFactorInstruction',
};
</script>
<style lang="sass" scoped>
.TwoFactorInstruction
    display: flex
    flex-direction: column
    align-items: center
    color: #fff
    gap: 2rem
    letter-spacing: .065rem
    padding: 0 2rem
    &__logos
        display: flex
        gap: 3rem
    &__title
        font-size: 1.5rem
        font-weight: 600
        text-align: left
    &__point
        &.center
        justify-content: center
        max-width: 575px
        display: flex
        align-items: center
        gap: 2rem
        &__number
            font-size: 2.5rem
        &__description
            font-size: 1rem
            line-height: 1.5rem
            font-weight: 300
            text-align: justify
</style>



// WEBPACK FOOTER //
// src/components/Common/LayoutLeftPanels/TwoFactorInstruction.vue